// Module
var code = `<section class="ai-prompt-surface">
  <header class="ai-prompt-header">
    <h1 class="ai-prompt-title">{{title}}</h1>

    <h2 class="ai-prompt-subtitle">{{subtitle}}</h2>

    <p class="ai-prompt-description">
      {{description}}
    </p>
  </header>

  <article class="ai-prompt-card"
           data-prompt-type="{{promptType}}"
           data-tone="{{tone}}"
           data-version="{{metadata.version}}">

    <div class="ai-prompt-meta">
      <div class="ai-prompt-meta-left">
        <span class="meta-item">Version {{metadata.version}}</span>
        <span class="meta-item">Created {{metadata.createdAt}}</span>
        <span class="meta-item meta-canonical">Canonical Prompt</span>
      </div>

      <button class="ai-copy-button"
              type="button"
              data-copy-target=".ai-prompt-content"
              aria-label="Copy prompt to clipboard">
        Copy
      </button>
    </div>

    <pre class="ai-prompt-content">
{{promptText}}
    </pre>

  </article>
</section>
`;
// Exports
module.exports = code;